import { ref, toRefs, onMounted, onBeforeUnmount, watch } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';

import { logintest, msgHandler } from '@/lib/common';
import { config } from '@/config';
import { listCustomAreas, listCustomAreaByCompany } from '@/graphql/queries';

export const ClientCustomComponentSetup = (props: any) => {
  const { type, company, device } = toRefs(props);
  
  let currentUser = ref({});
  let loggedIn = ref(false);

  const refFrame = ref();
  const ifheight = ref(0);
  const content = ref('');

  const classes = ['client', 'c-sec'];
  if(props.type == 'company') classes.push('no-style-customer');
  if(props.type == 'rgcontent') classes.push('no-style-promotion');
  if(props.type == 'advertisement') classes.push('no-style-advert');

  onMounted(async () => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
    window.addEventListener('message', listenMessage);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('message', listenMessage);
  });

  const listenMessage = (evt:any) => {
    if(evt.origin !== config.STATIC_CONTENT_ORIGIN) return;
    if(evt.data.href !== content.value) return;
    const objects = {
      height: ifheight,
      user: currentUser
    };
    msgHandler[evt.data.method](evt, objects);
    // ifheight.value = parseInt(evt.data.height);
  };

  const initView = () => {
    queryCustomArea();
  };
  const clearView = () => {
    content.value = '';
  };

  const queryCustomArea = async () => {
    if(type.value && company.value) {
      // const params = {
      //   filter: {and: {companyId: {eq: company.value}, device: {eq: device.value||'pc'}}},
      //   limit: 100
      // };
      // const res: any = await API.graphql(graphqlOperation(listCustomAreas, params));

      const params = {
        companyId: company.value,
        filter: {and: {type: {eq: type.value}, device: {eq: device.value||'pc'}}},
        sortDirection: 'DESC',
        limit: 10
      };
      const res: any = await API.graphql(graphqlOperation(listCustomAreaByCompany, params));

      if(res) {
        const r = (res.data.listCustomAreaByCompany.items.length > 0) ? res.data.listCustomAreaByCompany.items[0].content: '';
        const regex = new RegExp('^http[s]?://');
        if(regex.test(r)) {
          content.value = r;
        } else {
          content.value = (r.length > 0) ? `${config.STATIC_CONTENT_ORIGIN}${r}`: '';
        }
      }
    }
  };

  watch(company, () => {
    initView();
  });

  return {
    refFrame,
    ifheight,
    content,
    classes
  };
}
